import {createStyles, Theme} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";

export const PausedStatusBackground = '#FCF3DA';
export const PausedStatusRowBackground = '#FEF9EC';
export const PausedStatusColor = '#8A6A16';

export const ActiveStatusBackground = '#E0F7F4';
export const ActiveStatusColor = '#008876';

export const EnrolledStatusBackground = '#E8EAFD';
export const EnrolledStatusColor = '#4A5DBF';

export const DiscontinuedStatusBackground = '#FDE8E8';
export const DiscontinuedStatusColor = '#C71C1C';

export const PatientStatusBadgeStyle = createStyles({
    badge: {
        display: 'inline-block',
        whiteSpace: 'nowrap',
        fontWeight: 700,
        borderRadius: '12px',
        padding: '4px 12px',
    },
    paused: {
        backgroundColor: PausedStatusBackground,
        color: PausedStatusColor,
    },
    active: {
        backgroundColor: ActiveStatusBackground,
        color: ActiveStatusColor,
    },
    enrolled: {
        backgroundColor: EnrolledStatusBackground,
        color: EnrolledStatusColor,
    },
    discontinued: {
        backgroundColor: DiscontinuedStatusBackground,
        color: DiscontinuedStatusColor,
    },
});

export const usePatientStatusBadgeStyle = makeStyles((theme: Theme) => PatientStatusBadgeStyle);
